var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "editor-footer" },
    [
      _c("el-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
        [_vm._v("确定")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }